import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/votes";

export default createStore({ Model });
